<template>
  <div class="template-container">
    <div class="card-black">
    <div class="card-header">
        <!-- Per tornare indietro -->
        <a href="#" @click="goBack" class="icon-link">
          <span class="material-icons">chevron_left</span>
        </a>
        <span>Fusco Fit Studio</span>
        <!-- Per andare alla home -->
        <a href="#/user" class="icon-link">
          <span class="material-icons">home</span>
        </a>
      </div>
      <div class="titolo-card">
        <h1>I TUOI ORDINI</h1>
      </div>    <div v-for="order in orders" :key="order.orderId" class="card-black-orders">
      <!-- Header dell'ordine che può essere cliccato per espandere i dettagli -->
      <div class="card-header2" @click="toggleAccordion(order.orderId)">
        <!-- Icona a sinistra (aggiungi la classe appropriata per l'icona) -->
        <div class="icon-column">
          <span class="material-icons">shopping_cart</span> <!-- Esempio di icona -->
        </div>
        <!-- Riepilogo del prodotto e data a destra dell'icona -->
        <div class="text-column">
          <div class="header-text">{{ order.products.map(p => p.name).join(', ') }}</div>
          <div class="text-card">{{ formatDate(order.orderDate) }}</div>
        </div>
        <!-- Indicatore di espansione -->
        <div class="icon-column-right">
          <span v-if="isOrderInWarningPeriod(order.orderDate)" class="warning-badge">IN SCADENZA</span>
        <span v-else-if="isOrderExpired(order.orderDate)" class="new-badge">SCADUTO</span>
          <span class="material-icons">chevron_right</span> <!-- Esempio di icona -->
        </div>
      </div>
      <!-- Dettagli dell'ordine -->
      <div v-if="currentAccordion === order.orderId" class="order-details">
        <!-- Tutti i dettagli qui -->
       <!-- <p><strong>ID Ordine:</strong> {{ order.orderId }}</p> -->
        <p><strong>Totale:</strong> {{ order.totalPrice }}€</p>
        <p><strong>Metodo di Pagamento:</strong> {{ order.paymentMethod }}</p>
        <p><strong>Stato Ordine:</strong> {{ order.statusOrder }}</p>
        <p><strong>Descrizione:</strong></p>
        <ul>
          <li v-for="product in order.products" :key="product.id">
            {{ product.name }} - {{ product.price }}€ ({{ product.description }})
          </li>
        </ul>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { getAuth } from 'firebase/auth';
import { getFirestore, query, where, collection, getDocs } from 'firebase/firestore';

export default {
  name: 'OrdersComponent',
  data() {
    return {
      orders: [],
      currentAccordion: null

    }
  },
  created() {
    this.fetchOrders();
  },
  methods: {
    async fetchOrders() {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        const db = getFirestore();
        const ordersQuery = query(collection(db, "orders"), where("uid", "==", user.uid));
        const querySnapshot = await getDocs(ordersQuery);

        this.orders = querySnapshot.docs.map(doc => ({
          ...doc.data(),
          id: doc.id
        }));
      }
    },

    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = timestamp.toDate(); // Converte il Timestamp in un oggetto Date JavaScript
      return date.toLocaleDateString("it-IT"); // Formatta la data in un formato leggibile
    },

    isOrderInWarningPeriod(orderDate) {
    if (!orderDate) return false;
    const orderDateObject = orderDate.toDate(); // Converte il Timestamp in un oggetto Date
    const now = new Date(); // Data corrente
    const twentyThreeDaysAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 23);
    const thirtyDaysAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);

    // Controlla se la data dell'ordine è compresa tra il 23° e il 30° giorno
    return orderDateObject > thirtyDaysAgo && orderDateObject <= twentyThreeDaysAgo;
  },

  isOrderExpired(orderDate) {
    if (!orderDate) return false;
    const orderDateObject = orderDate.toDate();
    const now = new Date();
    const thirtyOneDaysAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 31);

    // Controlla se la data dell'ordine è dal 31° giorno in poi
    return orderDateObject <= thirtyOneDaysAgo;
  },

    toggleAccordion(orderId) {
    this.currentAccordion = this.currentAccordion === orderId ? null : orderId;
  },
  
  goBack() {
      this.$router.go(-1); // Usa this.$router per accedere al router di Vue
    },

  }
  
}
</script>



<style scoped>

.expire-badge {
  position: absolute; /* Posiziona la scritta rispetto al suo contenitore più vicino con position: relative */
  top: -5px; /* Distanza dal top del contenitore */
  right: 10px; /* Distanza dal lato destro del contenitore */
  background-color: rgb(255, 106, 0); /* Colore di sfondo per la scritta */
  color: white; /* Colore del testo */
  padding: 3px; /* Un po' di padding intorno al testo */
  border-radius: 5px; /* Angoli arrotondati per l'etichetta */
  font-size: 0.7em; /* Riduci la dimensione del font, se necessario */
  z-index: 1; /* Assicurati che la scritta sia sopra gli altri elementi */
}
.card-black-orders {
color: #ffffff;

}
.icon-column {
  /* Stili per l'icona a sinistra */
  flex: 0 0 auto; /* Imposta l'icona per non crescere o restringersi */
  /* ... altri stili per icon-column ... */
}

.template-container {
  background-color: #111111; /* Sostituisci con il colore di sfondo che preferisci */
min-height: 100vh;
}



.titolo-card {
color:#ababab;
font-size: 11px;
font-style: italic;
margin-bottom: 30px;
margin-top: 30px;
}

.card-black2 {
  position: relative; /* Imposta il riferimento per il posizionamento assoluto del figlio */
  color: #333;
  background: #111111;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  border-radius: 12px;
  overflow: hidden;
  max-width: 1200px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 230px;
}

.card-header2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(45deg, #232323 0%, #232323 100%);
  color: white;
  border-radius: 23px;
  margin-bottom: 20px;
  margin-top: 20px;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 23px;
  padding-right: 8px;
  position: relative;
}


.icon-column {
  flex: 0 0 auto; 
  color: rgb(139, 139, 139);

}

.icon-column-right {
  flex: 0 0 auto; 
  color: rgb(139, 139, 139);
  margin-right: 20px;

}

/* Stile per ingrandire il checkbox */
.icon-column-right input[type="checkbox"] {
  /* Aumenta la dimensione del checkbox */
  transform: scale(1.5);
  /* Opzionalmente, aggiungi del margine per spostarlo se necessario */
  margin: 5px;
}

.text-column {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start; /* Assicura che il contenuto sia allineato a sinistra */
  padding-left: 10px;
  padding-right: 20px;
}


.icon-column-right {
  /* Stili per l'icona indicatore a destra */
  flex: 0 0 auto; /* Imposta l'icona per non crescere o restringersi */
  /* ... altri stili per icon-column-right ... */
}

.header-text {
  font-weight: bold;
  margin-bottom: 4px; /* Spazio tra titolo e descrizione */
}

.text-card {
  color: #ababab; /* Colore per il testo descrittivo */
  font-size: 0.8em; /* Riduci la dimensione del font per il testo descrittivo */
  text-align: left; /* Assicurati che il testo sia allineato a sinistra */

}


@media screen and (min-width: 768px) {

.card-black2 {
  background-color: #111111;
  max-width: 800px;
  margin: auto;
  padding-bottom: 250px;
  box-shadow: none;
  
}

.template-container {
  background-color: #111111; /* Sostituisci con il colore di sfondo che preferisci */
  /* Altri stili per il contenitore, se necessari */
}

}
</style>
